import React from 'react';
import Badge from '@spark/ui-components/components/Badge';
import styled from 'styled-components';
import { Button } from '@spark/ui-components/components/Button'; // Função para formatar data

const formatDate = dateString => {
  if (!dateString) return '-';

  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    return dateString;
  }
}; // Função para truncar texto


const truncateText = (text, maxLength = 50) => {
  if (!text) return '-';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const columns = () => [{
  id: 'Titulo',
  accessorKey: 'Titulo',
  header: 'Título',
  size: 200,
  enableSorting: true,
  enableColumnFilter: true,
  cell: ({
    getValue
  }) => {
    const value = getValue();
    return <div title={value}>
          {truncateText(value, 30)}
        </div>;
  }
}, {
  id: 'Descricao',
  accessorKey: 'Descricao',
  header: 'Descrição',
  size: 300,
  enableSorting: true,
  enableColumnFilter: true,
  cell: ({
    getValue
  }) => {
    const value = getValue();
    return <div title={value}>
          {truncateText(value, 50)}
        </div>;
  }
},{
  id: 'NumeroContainer',
  accessorKey: 'NumeroContainer',
  header: 'Número do Container',
  size: 150,
  enableSorting: true,
  enableColumnFilter: true,
  cell: ({
    getValue
  }) => {
    const numeroCarga = getValue();
    return numeroCarga || '-';
  }
}, {
  id: 'NumeroDaCarga',
  accessorKey: 'NumeroDaCarga',
  header: 'Número da Carga',
  size: 150,
  enableSorting: true,
  enableColumnFilter: true,
  cell: ({
    getValue
  }) => {
    const numeroCarga = getValue();
    return numeroCarga || '-';
  }
}, {
  id: 'NumerosNotasFiscais',
  accessorKey: 'NumerosNotasFiscais',
  header: 'Números das Notas',
  size: 200,
  enableSorting: true,
  enableColumnFilter: true,
  cell: ({
    getValue
  }) => {
    const numerosNotas = getValue();
    if (!numerosNotas) return '-'; // Se há múltiplas notas, mostrar as primeiras e indicar quantas há

    const notasArray = numerosNotas.split(',');

    if (notasArray.length <= 3) {
      return notasArray.join(', ');
    } else {
      return `${notasArray.slice(0, 3).join(', ')} +${notasArray.length - 3} mais`;
    }
  }
}, {
  id: 'UsuarioNome',
  accessorKey: 'UsuarioNome',
  header: 'Criado por',
  size: 150,
  enableSorting: true,
  enableColumnFilter: true,
  cell: ({
    getValue
  }) => {
    const value = getValue();
    return value || '-';
  }
}, {
  id: 'DataCriacao',
  accessorKey: 'DataCriacao',
  header: 'Data Criação',
  size: 150,
  enableSorting: true,
  enableColumnFilter: true,
  cell: ({
    getValue
  }) => {
    const value = getValue();
    return formatDate(value);
  }
}];
